import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Invoice from "../reports/Invoice";
import { updateTagsOnTimeEntires } from "../../libs/toggl/updateTagsOnTimeEntries";

export function SendInvoice({ timeEntires, data, onClick, onInvoiced }) {
  // state for modal
  const [open, setOpen] = React.useState(false);

  const handleDidSendInvoice = () => {
    setOpen(false);

    updateTagsOnTimeEntires(
      timeEntires,
      ["invoiced"],
      (data) => {
        onInvoiced();
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleSendInvoiceClick = () => {
    setOpen(true);
    onClick();
  };

  if (!data) {
    return null;
  }
  return (
    <Box>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Send Invoice</DialogTitle>
        <DialogContent>
          <DialogContentText>Did you send the invoice?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>No</Button>
          <Button variant="contained" onClick={handleDidSendInvoice}>
            I sent it!
          </Button>
        </DialogActions>
      </Dialog>

      <PDFDownloadLink
        document={<Invoice invoice={data} />}
        fileName="invoice.pdf"
      >
        {({ blob, url, loading, error }) => (
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendInvoiceClick}
          >
            {loading ? "generating..." : "Send Invoice"}
          </Button>
        )}
      </PDFDownloadLink>
    </Box>
  );
}
